/* ImageEditComponent.js */

"use strict";
const EventEmitter = require('events').EventEmitter;
const Renderer = require("./ImageEditRenderer");

class ImageEditComponent extends EventEmitter {
    constructor({callback, existingImage, config, opts}) {
        super();
        // this._context = context;
        this._existingImage = existingImage;
        this._config = config;
        this.callback = callback;
        this._editorOpts = opts;
        this._renderer = new Renderer(this);
        this._registerListeners();
        this._renderer.render();
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners(){

    }
    _unregisterListeners(){

    }
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    // prettier-ignore
    set "$teve.ui.context"(context) { //jshint ignore:line
        this._context = context;
    }
    get renderer(){
        return this.getRenderer();
    }
    getRenderer(){
        return this._renderer;
    }
    
    shutdown(){
        this._unregisterListeners();
        let prom = this._renderer._shutdown();
        this._renderer = undefined;
        this._existingImage = undefined;
        this._config = undefined;
        this.callback = undefined;
        this._context = undefined;
        this._editorOpts = undefined;
        return prom;
    }
    
    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/
    closePopUp() {
        this.rejectPopUp({ userRejected: true });
    }
    rejectPopUp(data) {
        this._context.reject(data);
    }
    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}
module.exports=ImageEditComponent;